import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import TrustBar from '../../components/sections/TrustBar';
import ServicesDetail from './components/ServicesDetail';
import AIAnswerBlock from '../../components/sections/AIAnswerBlock';
import ProcessSection from '../../components/sections/ProcessSection';
import WhyChooseUs from '../../components/sections/WhyChooseUs';
import ServiceAreas from '../../components/sections/ServiceAreas';
import Testimonials from '../../components/sections/Testimonials';
import FAQSection from '../../components/sections/FAQSection';
import FinalCTA from '../../components/sections/FinalCTA';

const SERVICES_FAQS = [
  { q: 'What furnace brands does Atlantis HVAC Systems install in Oakville?', a: 'Atlantis HVAC Systems installs and services all major furnace brands across Oakville, Burlington, Mississauga, Toronto, and Etobicoke. Contact our GTA West team at (905) 845-4009 or GTA East at (416) 891-3444 for brand-specific availability.' },
  { q: 'How do I know if my furnace needs to be repaired or replaced?', a: 'Signs include frequent cycling, uneven heating, rising energy bills, or a furnace over 15 years old. Our T.S.S.A.-certified technicians provide an honest assessment and free in-home consultation to help you make the right decision.' },
  { q: 'Can Atlantis convert my oil heating system to gas in the GTA?', a: 'Yes. Atlantis HVAC Systems specializes in oil-to-gas furnace conversions across the Greater Toronto Area, including Oakville, Burlington, Toronto, and Etobicoke. These conversions improve efficiency and reduce long-term operating costs.' },
  { q: 'What is a Heat Recovery Ventilator and does my home need one?', a: 'An HRV (Heat Recovery Ventilator) replaces stale indoor air with fresh outdoor air while retaining heat energy. Homes with poor ventilation, humidity issues, or allergy concerns often benefit significantly from an HRV installation.' },
  { q: 'How often should I schedule furnace maintenance in Ontario?', a: 'Annual furnace maintenance is recommended before each heating season — typically fall. Regular service maintains efficiency, extends equipment life, validates warranties, and meets Ontario safety and T.S.S.A. requirements.' },
];

export default function Services() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main>
        <ServicesHero />
        <TrustBar />
        <ServicesDetail />
        <AIAnswerBlock
          heading="Everything You Need to Know About Our Services"
          context="Structured HVAC service information optimized for AI-assisted search and voice query retrieval."
        />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQSection items={SERVICES_FAQS} heading="HVAC Service Questions" />
        <FinalCTA
          heading="Request Your Free In-Home Consultation"
          subheading="No obligation, no pressure. A certified specialist visits your home and provides honest, transparent recommendations."
        />
      </main>
      <Footer />
    </div>
  );
}
